/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swap_Reason_VarietyInputs */

const en_us2_swap_reason_variety = /** @type {(inputs: Swap_Reason_VarietyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Just for variety`)
};

const pt_br2_swap_reason_variety = /** @type {(inputs: Swap_Reason_VarietyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só variar`)
};

const es_419_swap_reason_variety = /** @type {(inputs: Swap_Reason_VarietyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo para variar`)
};

const pt_pt2_swap_reason_variety = /** @type {(inputs: Swap_Reason_VarietyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só para variar`)
};

const fr_fr2_swap_reason_variety = /** @type {(inputs: Swap_Reason_VarietyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour varier`)
};

const de_de2_swap_reason_variety = /** @type {(inputs: Swap_Reason_VarietyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur Abwechslung`)
};

const it_it2_swap_reason_variety = /** @type {(inputs: Swap_Reason_VarietyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo per variare`)
};

/**
* | output |
* | --- |
* | "Just for variety" |
*
* @param {Swap_Reason_VarietyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_reason_variety = /** @type {((inputs?: Swap_Reason_VarietyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_Reason_VarietyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_reason_variety(inputs)
	if (locale === "es-419") return es_419_swap_reason_variety(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_reason_variety(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_reason_variety(inputs)
	if (locale === "de-DE") return de_de2_swap_reason_variety(inputs)
	if (locale === "it-IT") return it_it2_swap_reason_variety(inputs)
	return en_us2_swap_reason_variety(inputs)
});
export { swap_reason_variety as "swap.reason_variety" }